import * as React from 'react';
export var LoonaContext = React.createContext({});
//# sourceMappingURL=context.js.map